import { Swiper, SwiperSlide } from 'swiper/react'
import { PlatformListItem } from '../pListItem'
import { usePlatformsList } from '@/entities/platforms/store'
import { useUnit } from 'effector-react'
import { $innerWidth } from '@/entities/navigation/store'
import { Mousewheel } from 'swiper/modules'
import React, { useMemo } from 'react'

import 'swiper/css'
import { PlatformType } from '@/entities/platforms/types.ts'

export const SwiperPlatformList = React.memo(() => {
  const platformList: PlatformType[] = usePlatformsList()
  const memoizedPlatformList = useMemo(() => platformList, [platformList])

  const lastRealIndex = useMemo(() => {
    const slidesCount = memoizedPlatformList.length
    const lastRealIndex = slidesCount - 3
    return lastRealIndex
  }, [memoizedPlatformList])

  const innerWidth = useUnit($innerWidth)

  return (
    <span>
      <Swiper
        style={{
          width: innerWidth,
          willChange: 'transform',
          backfaceVisibility: 'hidden',
          transform: 'translate3d(0, 0, 0)',
        }}
        onTouchEnd={(swiper) => {
          setTimeout(() => {
            if (!swiper.animating) {
              swiper.slideTo(swiper.activeIndex)
            }
          }, 0) // idk why but it works only this way
        }}
        className="swiper-container"
        direction="horizontal"
        slidesPerView={2.5}
        touchRatio={0.8}
        grabCursor={false}
        freeMode={false}
        resistanceRatio={0.8}
        speed={420}
        mousewheel={{
          forceToAxis: true,
          thresholdTime: 0,
          thresholdDelta: 4,
          sensitivity: 0.1,
        }}
        onSlideChange={(swiper) => {
          if (swiper.activeIndex >= lastRealIndex) {
            swiper.slideTo(lastRealIndex)
          } else {
            swiper.allowSlideNext = true
          }
        }}
        spaceBetween={36}
        modules={[Mousewheel]}
      >
        {memoizedPlatformList.map((item) => {
          return (
            <SwiperSlide key={item.name}>
              <PlatformListItem {...item} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </span>
  )
})
